// src/routes/AppRoutes.js
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ProtectedRoute from '../components/Auth/ProtectedRoute';
import AdminLayout from '../components/layout/AdminLayout';
import UsersPage from '../pages/UsersPage';
import SettingsPage from '../pages/SettingsPage';
import NotFoundPage from '../pages/NotFoundPage';
import LoginPage from '../pages/LoginPage';
import ConfigurationsPage from '../pages/ConfigurationPage';
import OrdersPage from '../pages/OrdersPage';
import ESimPackagesPage from '../pages/ESimPackagesPage';
import CountriesPage from '../pages/CountriesPage';
import RegionsPage from '../pages/RegionsPage';
import EsimPackagesListRegion from '../pages/RegionalPackagesPage';
import LifetimePackages from '../pages/PrepaidPackagesPage';
import ContinentsPage from '../pages/ContinentsPage';
import ContentManagementPage from '../pages/ContentManagementPage';
import AppSettingsPage from '../pages/AppSettingsPage';

const AppRoutes = () => {
  return (
    <Routes>
      {/* Public Route */}
      <Route path="/login" element={<LoginPage />} /> {/* DÜZELTİLDİ */}

      {/* Private Routes */}
      <Route element={<ProtectedRoute />}>
        <Route element={<AdminLayout />}>
          {/* AdminLayout içindeki Outlet'e render edilecek sayfalar */}
          <Route path='/' index element={<OrdersPage />} /> {/* Artık ana sayfa Siparişler */}
          <Route path="/orders" element={<OrdersPage />} /> {/* DÜZELTİLDİ */}
          <Route path="/users" element={<UsersPage />} /> {/* DÜZELTİLDİ */}
          <Route path="/regions-package" element={<EsimPackagesListRegion />} /> {/* DÜZELTİLDİ */}
          <Route path="/lifetime-packages" element={<LifetimePackages />} /> {/* DÜZELTİLDİ */}
          <Route path="/packages" element={<ESimPackagesPage />} /> {/* DÜZELTİLDİ */}
          <Route path="/continents" element={<ContinentsPage />} /> {/* DÜZELTİLDİ */}
          <Route path="/countries" element={<CountriesPage />} /> {/* DÜZELTİLDİ */}
          <Route path="/regions" element={<RegionsPage />} /> {/* DÜZELTİLDİ */}
          <Route path="/configurations" element={<ConfigurationsPage />} /> {/* DÜZELTİLDİ */}
          <Route path="/content-management" element={<ContentManagementPage />} /> {/* DÜZELTİLDİ */}
          <Route path="/settings" element={<SettingsPage />} /> {/* DÜZELTİLDİ */}
          <Route path="/app-settings" element={<AppSettingsPage />} />
        </Route>
      </Route>

      {/* Eşleşmeyen Rotalar */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};

export default AppRoutes;